import { createApp } from 'vue'
import TDesign from 'tdesign-vue-next'
import 'tdesign-vue-next/es/style/index.css'

import App from './App.vue'
import router from './router'
import store from './stores'
import { useAuthStore } from './stores/auth'

// 导入样式
import './style/index.less'

// 创建应用实例
const app = createApp(App)

// 使用 Pinia 状态管理
app.use(store)

// 使用路由
app.use(router)

// 使用 TDesign 组件库
app.use(TDesign)

// 初始化认证状态
const authStore = useAuthStore()
authStore.initAuth()

// 挂载应用
app.mount('#app')